import * as React from 'react'
import ReactInfiniteScrollComponent from 'react-infinite-scroll-component'

// https://github.com/ankeetmaini/react-infinite-scroll-component
// TODO: prop types from package
function InfiniteScrollList(props) {
   return <ReactInfiniteScrollComponent {...props} />
}
export { InfiniteScrollList }
